import http from "../../services/http";

const getSexos = async () => {
  return await http("get", `v1/sexos/listar`, []);
};

export { getSexos };
